// src/hooks/useNotification.js (hook separado)
import { useContext } from 'react';
import NotificationContext from '@/contexts/notificationContext'

const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification debe ser usado dentro de NotificationProvider');
  }
  return context;
};

export default useNotification;